import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/accopenanalysisresultserv'

export default {
  state: {
    state_ACCopenAnalysisResult_GetPageResult: null,
    state_ACCopenAnalysisResult_GetDetailResult: null,
    state_ACCopenAnalysisResult_GetClientPageResult: null,
    state_ACCopenAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_ACCOPENANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisResult_GetPageResult = rst;
    },
    SET_ACCOPENANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisResult_GetDetailResult = rst;
    },
    SET_ACCOPENANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisResult_GetClientPageResult = rst;
    },
    SET_ACCOPENANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    ACCopenAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_ACCopenAnalysisResult_GetPageResult: state => {
      return state.state_ACCopenAnalysisResult_GetPageResult;
    },
    get_ACCopenAnalysisResult_GetDetailResult: state => {
      return state.state_ACCopenAnalysisResult_GetDetailResult;
    },
    get_ACCopenAnalysisResult_GetClientPageResult: state => {
      return state.state_ACCopenAnalysisResult_GetClientPageResult;
    },
    get_ACCopenAnalysisResult_ExportExcelResult: state => {
      return state.state_ACCopenAnalysisResult_ExportExcelResult;
    },
  }
}